module.exports = "img/flags/UY.12e4301.png";